import { Grid, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common';
import { ORDER_STATUS_LABELS } from '../constants/internalOrdersConstants';
import {
  getProjectLabelFromRecord,
  getWarehouseLabelFromRecord,
  sortProjectOptions,
} from '../utils/internalOrdersUtils';

const InternalOrdersFilters = ({
  filters,
  warehouses = [],
  projects = [],
  onFilterChange,
  onSelectChange,
}) => {
  return (
    <HeaderFilterBox variant="twoRows">
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <CustomSelect
            label="Estado"
            name="status"
            value={filters.status}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los estados</MenuItem>
            {Object.entries(ORDER_STATUS_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={3}>
          <CustomSelect
            label="Depósito destino"
            name="uuid_destination_warehouse"
            value={filters.uuid_destination_warehouse}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los depósitos</MenuItem>
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.uuid} value={warehouse.uuid}>
                {getWarehouseLabelFromRecord(warehouse)}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={3}>
          <CustomSelect
            label="Proyecto"
            name="uuid_project"
            value={filters.uuid_project}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los proyectos</MenuItem>
            {sortProjectOptions(projects).map((project) => (
              <MenuItem key={project.uuid} value={project.uuid}>
                {getProjectLabelFromRecord(project)}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={1.5}>
          <CustomTextField
            label="Desde"
            name="date_from"
            type="date"
            value={filters.date_from}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={1.5}>
          <CustomTextField
            label="Hasta"
            name="date_to"
            type="date"
            value={filters.date_to}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>
    </HeaderFilterBox>
  );
};

export default InternalOrdersFilters;
